export class BtcAddressInfo {
    public static fromObject(o: BtcAddressInfoEntry): BtcAddressInfo {
        return new BtcAddressInfo(
            o.path,
            o.address,
            o.used,
            o.balance,
        );
    }

    public static objectToBtcAddressType(o: BtcAddressInfoEntry): string {
        return o.address;
    }

    public constructor(
        public path: string,
        public address: string,
        public used: boolean,
        public balance?: number,
    ) {}

    public get index(): number {
        return Number(this.path.substring(this.path.lastIndexOf('/') + 1));
    }

    public toObject(): BtcAddressInfoEntry {
        return {
            path: this.path,
            address: this.address,
            used: this.used,
            balance: this.balance,
        };
    }

    public toBtcAddressType(): string {
        return this.address;
    }

    public equals(other: BtcAddressInfo): boolean {
        return this.path === other.path
            && this.address === other.address
            && this.used === other.used
            && this.balance === other.balance;
    }
}

/*
 * Database Types
 */
export interface BtcAddressInfoEntry {
    path: string;
    address: string;
    used: boolean;
    balance?: number;
}
